export const CATEGORIES = {
  GBP: "GBP",
  INGREDINET_SELECTION: "Ingredients Selection",
  GP: "Global Pricing (GP)",
  ASSET_TRANSFER: "Asset Transfer",
  RESTAURANT_SOLUTIONS: "Restaurant Solution Redirection",
};

export const ACTIONS = {
  OPEN_GBP_TILE: 'Open GBP Tile',
  REDIRECT_TO_GBP_PAGE: 'Redirect to GBP Page',
  SCHEDULE_CONSULTATION: 'Schedule Consultation',
  FIRST_TIME_COST_ROLLUP: "First-time cost roll-up",
  NO_FOR_FIRST_TIME_COST_ROLLUP: "No for First time cost roll-up",
  INITIATE_GENERIC_COST_ROLLUP: "Initiate generic cost roll-up",
  NO_FOR_GENERIC_COST_ROLLUP: "No for Generic cost roll up",
  RESOLVE_INGREDIENT_UNAVAILABILITY: "Resolve Ingredient Unavailability",
  RESOLVE_SPLIT_ITEM_ERRORS: "Resolve Split item errors",
  SELECT_REPLACEMENT_INGREDIENT: "Select Replacement Ingredient",
  QTY_UPDATE_FOR_REPLACEMENT_INGREDIENT: "Qty update for replacement ingredient",
  INGREDINET_REPLACEMENT_BUTTON: "Ingredient Replacement button",
  CUSTOM_INGREDIENT_COST_ROLLUP: "Custom Ingredient Cost roll up",
  CLAIM_LOCATION: "Claim Location",
  CREATE_AND_CLAIM: "Create and Claim",
  LINK_TO_SYSCOSTUDIO: "Link to Syscostudio",
  REQUEST_ADMIN_RIGHTS: "Request Admin Rights",
  SEARCH_LOCATION: "Search Location",
  NEW_TRANSFER: "New Transfer",
  ASSET_TRNASFER_CONFIRMATION: "Asset Transfer Confirmation",
  VIEW_ASSET_TRANSFER_INFO: "View Asset Transfer Info",
  REQUEST_PROJECT: "Request a Project",
};